//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the timespan represented by each of the StreakType bits. */
export const StreakOccurrenceFrequency = {
    /** The StreakType has bits that represent a day. */
    Daily: 0,

    /** The StreakType has bits that represent a week. */
    Weekly: 1,

    /** The StreakType has bits that represent a month. */
    Monthly: 2,

    /** The StreakType has bits that represent a year. */
    Yearly: 3
} as const;

/** Represents the timespan represented by each of the StreakType bits. */
export const StreakOccurrenceFrequencyDescription: Record<number, string> = {
    0: "Daily",

    1: "Weekly",

    2: "Monthly",

    3: "Yearly"
};

/** Represents the timespan represented by each of the StreakType bits. */
export type StreakOccurrenceFrequency = typeof StreakOccurrenceFrequency[keyof typeof StreakOccurrenceFrequency];
